module.exports = __webpack_public_path__ + "../resources/img/ic_re_arc_spark_glass_img.69e0d36c.svg";